<template lang="pug">
#app.jfApp
  #jfLogin
    //- 登录框
    #jf-wrap
      img(src='/static/images/jf/logo-login-teacherClient.png')
      p.grey3 欢迎登录
      Form(
        :toggleFindPwd='() => {}'
        clientType='teacher',
      )
    #jfFooter {{ copyright + cfName + $t("footer.copyright") }}
</template>

<script>
import { $cookie } from '@/util/Util'
import Form from './components/Form'
import { getCfg } from '@/api'

export default {
  name: 'Login',
  components: { Form },
  data() {
    const { cfName } = window.ConfigNew.header
    const { copyright } = window.ConfigNew.footer
    return {
      cfName,
      copyright
    }
  },
  methods: {},
  created() {
    let timeStamp = new Date().getTime()
    getCfg({ token: timeStamp })
      .then(data => {
        $cookie.set('hasZy', data.only_zy) // 仅作业
        $cookie.set('hasCp', data.only_cp) // 仅测评
        $cookie.set('model', data.to_b) // 1:2B else:2C 配置
        localStorage.setItem('cpUrl', data.cpUrl)
        localStorage.setItem('zyUrl', data.zyUrl)
        localStorage.setItem('mUrl', data.mUrl)
        localStorage.setItem('accUrl', data.ywUrl)
        localStorage.setItem('resUrl', data.resource_url + '/')
        localStorage.setItem('gatewayUrl', data.gatewayUrl)
      })
      .catch(res => {
        console.info(res)
      })
  },
  mounted() {}
}
</script>

<style lang="less">
@import url('./app.less');
body {
  overflow-y: auto;
}
.jfApp {
  height: 100vh;
  overflow: hidden;
}
#jfLogin {
  position: relative;
  height: 100%;
  flex: 1;
  justify-content: center;
  align-items: center;
  background: #21bd7c url(/static/images/jf/bg.png) no-repeat center bottom;
  background-size: contain;

  #jf-wrap {
    display: flex;
    flex-direction: column;
    position: absolute;
    top: 50%;
    left: 0;
    right: 0;
    width: 960px;
    height: 720px;
    margin: -360px auto 0;
    border-radius: 36px;
    background: #fff url(/static/images/jf/bg-box.png) no-repeat center bottom;
    background-size: contain;

    > img {
      width: 318px;
      margin: 24px 0 0 28px;
    }

    > p {
      margin: 66px auto 0;
      font-size: 36px;
      text-align: center;
    }

    .loginOperation {
      flex: 1;
      width: 100%;
      position: relative;
      margin: 0;
      margin-top: 80px;
      right: 0;
      top: 0;
      box-shadow: none;
      background: transparent;

      .loginpanel {
        width: 100%;
        background: transparent;
        > div {
          width: 420px;
          border: 0;

          &.username,
          &.password {
            height: 70px;
            border-bottom: 1px solid #eeeff6;
          }
        }

        .form-input {
          border: 0;

          > div {
            width: 22px;
            background: transparent;
            i {
              width: 22px;
              height: 22px;
            }
          }
          .icon_username {
            background: url(/static/images/jf/jficon-user.png) no-repeat center center;
            background-size: contain;
          }
          .icon_password {
            background: url(/static/images/jf/jficon-password.png) no-repeat center center;
            background-size: contain;
          }
          .icon_delete {
            width: 24px;
            height: 24px;
            background: url(/static/images/jf/jficon-clear.png) no-repeat center center;
            background-size: contain;
            margin-right: 0;
          }
          > input {
            padding: 0 20px;
            font-size: 16px;
          }
        }

        .m30 {
          margin-top: 103px !important;
        }
        .operation {
          margin: 30px auto 52px;
          > span {
            font-size: 16px;
          }
        }
        .submit {
          button {
            width: 420px;
            height: 56px;
            background: linear-gradient(90deg, #24cc7c 0%, #21bd73 100%);
            border-radius: 28px;
            font-size: 22px;
          }
        }

        .error-tip {
          margin-top: 40px;
          justify-content: center;
          padding-left: 0;
          background: none;

          .error-tip-text {
            font-size: 16px;
            color: #ff6666;
          }
        }
      }
    }
  }

  #jfFooter {
    position: absolute;
    bottom: 20px;
    width: 100%;
    color: #fff;
    font-size: 16px;
    opacity: 0.8;
    text-align: center;
  }
}

@media screen and (max-height: 768px) {
  #jfLogin {
    #jf-wrap {
      width: 680px;
      height: 510px;
      border-radius: 30px;
      margin: -255px auto 0;

      > img {
        width: 216px;
        margin: 16px 0 0 20px;
      }

      > p {
        margin: 50px auto 0;
        font-size: 24px;
      }

      .loginOperation {
        margin-top: 50px;

        .loginpanel {
          width: 100%;
          background: transparent;
          > div {
            width: 294px;

            &.username,
            &.password {
              height: 56px;
            }
          }

          .form-input {
            > div {
              width: 16px;
              i {
                width: 16px;
                height: 16px;
              }
            }
            .icon_delete {
              width: 16px;
              height: 16px;
            }
            > input {
              padding: 0 12px;
              font-size: 14px;
            }
          }

          .operation {
            margin: 15px auto 36px;
            > span {
              font-size: 12px;
            }
          }
          .submit {
            button {
              width: 294px;
              height: 40px;
              font-size: 18px;
            }
          }

          .error-tip {
            margin-top: 36px;

            .error-tip-text {
              font-size: 12px;
            }
          }
        }
      }
    }

    #jfFooter {
      bottom: 16px;
      font-size: 12px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/login/teacherClientApp.vue